import { BackgroundCheckData } from '../entities/background-check';

export function isBackgroundCheckConsentGiven(data: Pick<BackgroundCheckData, 'consent'>) {
    return data.consent;
}
